import toast from 'react-hot-toast';
import {
  aggregateIngredients,
  aiNutrition,
  getFallbackNutritionFacts,
  updateRecipeNutrition,
} from '@recipe/shared';

/**
 * Calculate nutrition facts in the background and save via API.
 * This function is designed to run after a recipe has already been saved,
 * so it doesn't block the UI.
 *
 * @param {string} recipeId - Recipe ID
 * @param {Object} formData - The recipe form data containing parts and title
 */
export const calculateAndSaveNutrition = async (recipeId, formData) => {
  let loadingToastId;

  try {
    const sortedIngredients = aggregateIngredients(formData.parts);

    let nutritionFacts;
    try {
      loadingToastId = toast.loading(`正在计算 ${formData.title} 的营养成分...`);
      nutritionFacts = await aiNutrition(sortedIngredients);
      toast.dismiss(loadingToastId);
      toast.success(`${formData.title} 营养成分计算成功！`);
    } catch (apiError) {
      console.warn('API nutrition failed, using local estimate:', apiError);
      nutritionFacts = getFallbackNutritionFacts(sortedIngredients);
      if (loadingToastId) toast.dismiss(loadingToastId);
      toast.success(`使用 ${formData.title} 的估算营养值`);
    }

    await updateRecipeNutrition(recipeId, nutritionFacts);
  } catch (error) {
    if (loadingToastId) toast.dismiss(loadingToastId);
    console.error('Failed to update nutrition:', error);
    toast.error(`计算 ${formData.title} 营养成分失败`);
  }
};
